import type { PayloadAction } from '@reduxjs/toolkit';
import type { PrintLog, PrintElement } from '@features/printer/types';

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  logs: [] as PrintLog[],
};

const printerLogSlice = createSlice({
  name: 'printerLog',
  initialState,
  reducers: {
    addNewLog: (state, action: PayloadAction<PrintLog>) => {
      state.logs.push(action.payload);
    },
    addNewLogs: (state, action: PayloadAction<PrintLog[]>) => {
      state.logs = [...state.logs, ...action.payload];
    },
    updateLog: (state, action: PayloadAction<{ id: string; patch: Partial<PrintLog> }>) => {
      const log = state.logs.find((item) => item.id === action.payload.id);
      if (log) {
        Object.assign(log, action.payload.patch);
      }
    },
    addNewLogFromPrinterElement: (
      state,
      action: PayloadAction<{ printElement: PrintElement; pickingType: string; id?: string }>
    ) => {
      const printElement = action.payload.printElement;
      const type = action.payload.pickingType;
      const log: PrintLog = {
        id: action.payload.id,
        date: new Date().toISOString(),
        name: printElement.title!,
        type,
        link: printElement.url ?? '',
      };
      state.logs.push(log);
    },
  },
});

export const { addNewLog, addNewLogs, updateLog, addNewLogFromPrinterElement } = printerLogSlice.actions;

export default printerLogSlice.reducer;
